var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10V15L26.6667 8.33335L20 1.66669V6.66669C12.6334 6.66669 6.66669 12.6334 6.66669 20C6.66669 22.6167 7.43335 25.05 8.73335 27.1L11.1667 24.6667C10.4167 23.2834 10 21.6834 10 20C10 14.4834 14.4834 10 20 10ZM31.2667 12.9L28.8334 15.3334C29.5667 16.7334 30 18.3167 30 20C30 25.5167 25.5167 30 20 30V25L13.3334 31.6667L20 38.3334V33.3334C27.3667 33.3334 33.3334 27.3667 33.3334 20C33.3334 17.3834 32.5667 14.95 31.2667 12.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3b7a08c328611aebeb91580cab5ca826.svg";
export { ForwardRef as ReactComponent };